<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" class="text-center mt-12">
        <h1 v-if="isPayment">Thank you for your payment!</h1>
        <h1 v-else>Great, let’s get you your will now!</h1>
        <br />
        <p class="success-thank-you">
          A PDF of your will has been sent to the email address which you signed
          up with. You can also download a copy by clicking the Download Will
          button below. If you have any questions regarding your will, please
          email us at:
          <a
            href="mailto:support@quickwill.co.za?Subject=I%20have%20a%20question%20regarding%20my%20Quickwill."
            target="_top"
            >support@quickwill.co.za</a
          >.
        </p>
        <v-col cols="12" class="mt-4">
          <DownloadWill v-if="!$apollo.loading" :testator="testator" />

          <div v-else class="text-center">
            <v-progress-circular indeterminate color="primary" />
          </div>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';
  import DownloadWill from '../common/DownloadWill';

  export default {
    name: 'SuccessPaymentPage',
    components: {
      DownloadWill,
    },
    props: {
      transactionType: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        testator: {},
      };
    },
    computed: {
      isPayment() {
        return this.transactionType == 'Payment';
      },
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        fetchPolicy: 'network-only',
      },
    },
  };
</script>

<style scoped>
  .success-thank-you {
    width: 65%;
    margin: auto;
  }
</style>
